export const cookiesPopup = {
  text: `Utilizamos cookies para garantizarle la mejor experiencia en nuestro sitio web.`,

  accept: 'Acepte',
};